import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { amenitiesRoutes } from './routes';
export class Amenities {
  constructor() {
    _defineProperty(this, "routes", amenitiesRoutes);
  }
  async getAllAmenities(options) {
    const resp = await requestService('property').get(this.routes.baseUrl, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getAllCommonAreaAmenities(options) {
    const resp = await requestService('property').get(this.routes.baseUrlCommonArea, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async saveCommonAreaAmenitiesToProperty(options) {
    let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'All';
    const resp = await requestService('property').get("".concat(this.routes.baseUrl, "?type=").concat(type), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}